import api from "../../api";
import utils from "../../utils";
import regex from "../../regex";
import Lottie from "react-lottie-player";
import values from "../../values";
import anLogin from "../../../assets/animations/an-Login.json";
import OtpInput from "react-otp-input";
import dictionary from "../../dictionary";
import errorHandler from "../../utils/errorHandler";

import React from "react";

import { IItem } from "../../types/common.interface";
import { Col, Container, Row } from "react-bootstrap";
import {
  CustomButton2,
  CustomInput,
  CustomRadioButtonGroup,
  CustomTimer,
} from "../../components";

import "./index.scss";
interface iData {
  phoneNumber: string;
  otp: string;
}

const LoginAdminScreen = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [canResend, setCanResend] = React.useState<boolean>(false);
  const [isOtpSend, setIsOtpSend] = React.useState<boolean>(false);
  const [resendTime, setResendTime] = React.useState({
    initialMinute: 2,
    initialSeconds: 0,
  });
  const [selectedRole, setSelectedRole] = React.useState<IItem | null>({
    name: "ادمین",
    value: "ADMIN",
  });
  const [data, setData] = React.useState<iData>({
    phoneNumber: "",
    otp: "",
  });

  // ============================================== Use queries =======================================

  const sendVerificationCode = async () => {
    // const resSendCode = await api.post.common.sendVerificationSms({
    //   phoneNumber: data.phoneNumber,
    //   userType: selectedRole?.value,
    // });
    // return resSendCode;
  };

  const login = async () => {
    // const resLogin = await api.post.common.verifyCode({
    //   phoneNumber: utils.convertNumbers2English(data.phoneNumber),
    //   verificationCode: utils.convertNumbers2English(data.otp),
    //   userType: selectedRole?.value,
    // });
    // return resLogin;
  };

  const checkUserAdmin = async () => {
    var phoneNumber = data.phoneNumber;
    if (data.phoneNumber.charAt(0) === "0") {
      phoneNumber = data.phoneNumber.substring(1);
    }
    // const isUserAdmin = await api.getMethod.common.userAndTypeExist({
    //   phoneNumber: phoneNumber,
    //   userType: selectedRole?.value,
    // });
    // return isUserAdmin?.result?.isUserTypeExist;
  };

  const resendCode = async () => {
    // setResendTime({ initialMinute: 2, initialSeconds: 0 });
    // if (canResend) {
    //   setIsLoading(true);
    //   setCanResend(false);
    //   setIsOtpSend(false);
    //   if (await sendVerificationCode()) setIsOtpSend(true);
    //   setIsLoading(false);
    // }
  };

  // ============================================== functions =======================================

  const onRoleChange = (item: IItem | null) => {
    setSelectedRole(item);
  };

  const onSubmit = async () => {
    if (isOtpSend) {
      setIsLoading(true);
      const resLogin: any = await login();
      if (resLogin === "error") {
        utils.errorHandler(5014);
        setIsLoading(false);
      }
      const { token, userType, userId, fullName, avatar, balance, city } =
        resLogin;
      if (token) {
        utils.setLoginData({
          ...resLogin,
        });
        if (selectedRole)
          window.location.href = `${dictionary.roleToUrl(
            String(selectedRole?.value)
          )}`;
      }
    } else {
      // if (!regex.phoneNumber(data.phoneNumber)) return errorHandler(9010);
      setIsLoading(true);
      // @ts-ignore
      if (!(await checkUserAdmin())) {
        setIsLoading(false);
        return errorHandler(9003);
      }
      // @ts-ignore
      if (await sendVerificationCode()) setIsOtpSend(true);
      else errorHandler(9014);
      setIsLoading(false);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  return (
    <section id="login-screen-container">
      <Container fluid>
        <Row>
          <Col lg={6}>
            <div className="left-side">
              <div className="login-card">
                <h1>ورود ادمین</h1>
                <div
                  // className='role-holder'
                  style={{
                    pointerEvents: isOtpSend || isLoading ? "none" : "all",
                  }}
                >
                  <CustomRadioButtonGroup
                    menus={[{ name: "ادمین", value: "ADMIN" }]}
                    selected={selectedRole}
                    onClick={onRoleChange}
                    canNull={false}
                  />
                </div>
                <div className="phone-number-holder">
                  <div className="enter-number-container">
                    <CustomInput
                      isDisable={isOtpSend ? isOtpSend : false || isLoading}
                      maxLength={13}
                      value={utils.hyphenfyMobileNumber(data.phoneNumber)}
                      onValueChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setData({
                          ...data,
                          phoneNumber: event.target.value.replace(/[-]/g, ""),
                        });
                      }}
                      label="شماره‌ی موبایل"
                      placeHolder="09XX - XXX - XXXX"
                      textAlign="center"
                      leftIcon="fas fa-mobile"
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                  {isOtpSend && (
                    <div className="edit-number-wrapper">
                      <h4 className="edit-number-sub"> {" شماره‌ همراه "} </h4>
                      <h4
                        className="edit-number-text"
                        onClick={() => setIsOtpSend(!isOtpSend)}
                      >
                        تغییر
                      </h4>
                    </div>
                  )}
                </div>
                {isOtpSend && (
                  <div onKeyDown={handleKeyDown} className="mv opt-input">
                    <OtpInput
                      value={data.otp}
                      isInputNum
                      onChange={(event: string) =>
                        setData({ ...data, otp: event })
                      }
                      numInputs={5}
                      containerStyle={{
                        direction: "ltr",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      inputStyle={{
                        border: "none",
                        textAlign: "center",
                        width: "2.125rem",
                        backgroundColor: "#e1f5fe",
                        borderRadius: "0.313rem",
                        padding: "0.212rem",
                      }}
                    />

                    <div className="resend-code-holder">
                      {!canResend && (
                        <CustomTimer
                          time={resendTime}
                          onEnd={() => setCanResend(!canResend)}
                        />
                      )}
                      <h4 className="resend-code-text" onClick={resendCode}>
                        {canResend ? "کد را دوباره ارسال کنید" : "اعتبار کد"}
                      </h4>
                    </div>
                  </div>
                )}
                <CustomButton2
                  isLoading={isLoading}
                  onClick={onSubmit}
                  title={isOtpSend ? "ورود" : "ارسال کد"}
                  type="primary"
                />
              </div>
            </div>
          </Col>
          <Col lg={6}>
            <div className="right-side">
              <Lottie
                loop
                animationData={anLogin}
                play
                style={{ width: "100%", height: "90%" }}
              />
              {/* <div className="animation-subtitle">
                <div className="login-text">
                  <p>{"constants.LOGIN_SUBTITLE"}</p>
                  <p>{"constants.LOGIN_DESCRIPTION"}</p>
                </div>
              </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default LoginAdminScreen;
